export default "__VITE_ASSET__BVIuW7K$__"